import React from "react";
import * as Icons from "lucide-react";
import { FEATURES } from "../lib/constants";

const Pattern = ({ accent }) => {
  const color = accent === "green" ? "#39FF14" : "#00E5FF";
  return (
    <svg
      className="absolute -right-8 -top-8 opacity-[0.06] pointer-events-none"
      width="180"
      height="180"
      viewBox="0 0 180 180"
      fill="none"
    >
      {Array.from({ length: 14 }).map((_, i) => (
        <circle
          key={i}
          cx="90"
          cy="90"
          r={10 + i * 5}
          stroke={color}
          strokeWidth="1"
          fill="none"
        />
      ))}
    </svg>
  );
};

export const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-16 sm:py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 sm:gap-8 mb-10 sm:mb-14">
          <div className="max-w-2xl">
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">
              [ 01 — Capabilities ]
            </div>
            <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-semibold leading-[0.95] text-white">
              Battery intelligence,
              <br />
              <span className="brand-text-gradient">not battery anxiety.</span>
            </h2>
          </div>
          <p className="text-zinc-400 text-base sm:text-lg max-w-md leading-relaxed">
            Six things every electric vehicle owner should know about their pack — measured precisely, every session, automatically.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-3xl overflow-hidden">
          {FEATURES.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <div
                key={f.title}
                data-testid={`feature-card-${i}`}
                className="relative bg-black p-6 sm:p-8 lg:p-10 hover:bg-zinc-950 transition-colors group overflow-hidden"
              >
                <Pattern accent={f.accent} />
                <div
                  className="relative w-11 h-11 rounded-xl flex items-center justify-center border border-white/10 mb-6"
                  style={{
                    background:
                      f.accent === "green"
                        ? "rgba(57,255,20,0.06)"
                        : "rgba(0,229,255,0.06)",
                  }}
                >
                  <Icon
                    className="w-5 h-5"
                    strokeWidth={1.6}
                    style={{
                      color: f.accent === "green" ? "#39FF14" : "#00E5FF",
                    }}
                  />
                </div>
                <h3 className="font-display text-xl font-semibold text-white mb-2.5">
                  {f.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed">{f.desc}</p>

                <div className="absolute bottom-0 left-0 right-0 h-px brand-gradient opacity-0 group-hover:opacity-60 transition-opacity" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
